module.exports = __webpack_public_path__ + "img/process_1.179643c4.png";